import { navigateTo } from 'helpers/url';
import { noop } from 'helpers/utils';
import { DiagonalUpArrow } from 'styles/assets/icons';
import Box from 'UIKit/Box';

import classes from './MobileAlgoResources.module.scss';
import type { InformationCardProps } from './types';

const InformationCard = ({ name, icon, link }: InformationCardProps) => {
  return (
    <Box
      data-testid={`algo-resources-information-card-${name}`}
      className={classes.informationCard}
      onClick={() => navigateTo(link, '_blank')}
      onKeyDown={noop}
    >
      <Box className={classes.iconBox}>{icon}</Box>
      <Box as="span" className={classes.informationText}>
        {name}
      </Box>
      <Box data-testid={`${name}-card-arrow`} className={classes.diagonalArrowButton}>
        <DiagonalUpArrow className={classes.diagonalArrow} />
      </Box>
    </Box>
  );
};

export { InformationCard };
